<template>
  <DocsRenderer />
</template>
